<template>
   <b-row id="mainContainer">
      <div class="col-2" id="joe-mama" style="max-height: 200px">
         <coi-query
            id="coi-query"
            :orderStates="orderStates"
            :shippingTypes="shippingTypes"
            :marketAccounts="marketAccounts"
            :vendors="vendors"
            :countries="countries"
            :authorization="authorization"
            :requestInProgress="false"
            :activeSqlQuery="activeSqlQuery"
            @mutatedActiveQuery="mutatedActiveQuery"
         ></coi-query>
            <!--
               v-on:update:xyz="activeQuery = $event"" is completely pointless, since we need to
               call a function processQuery(..) in response to the change.
               This would mean we would have to wrap processQuery(..) in a watcher on activeQuery.
               @mutatedActiveQuery="processActiveQuery" is cleaner.
             -->
      </div>
      <div class="two pl-xl-2 pl-md-3 pl-sm-4" style="position: relative">
         <div class="b-container" fluid style="position: absolute">
            <div
               id="div-pagination"
               class="card d-flex"
               fluid
               v-bind:style="{ width: `${tDim.width}px` }"
            >
               <div class="card-body py-0 px-2" style="background: rgb(242 248 255)">
                  <div class="row" id="coi-pagination">
                     <div class="col-md-2">
                        <div class="d-flex justify-content-start">
                           <h3 class="mt-2 pt-1">Bestellungen</h3>
                        </div>
                     </div >
                        <div class="col-md-2">
                           <div class="d-flex justify-content-end text-center">
                              <div class="mt-2 ">
                                 <b>Lightmode</b>
                                 <b-form-checkbox v-model="userPreferenceStore.coi.lightMode" class="mx-auto" size="md" name="lightModeCheck" switch :value="true" :unchecked-value="false"></b-form-checkbox>
                              </div>
                           </div>
                        </div>
                     <div class="col-md-8">
                        <coi-pagination
                           ref="COIPagination"
                           @mutatedPagination="mutatedPagination"
                           :customerOrderCount="customerOrderCount"
                           :queryInProgress="queryInProgress"
                        />
                     </div>
                  </div>
               </div>
            </div>
               <div
                  id="div-customer-order-items"
                  class="card"
                  v-bind:style="{
                     height: `${tDim.height - 65}px`,
                     position: 'fixed',
                     top: `${tDim.pagination + 5}px`,
                     width: `${tDim.width}px`,
                     'overflow-y': 'scroll',
                     'overflow-x': 'hidden',
                  }"
               >
                  <!-- div card -->
                  <coi-list 
                     :customerOrders="customerOrders" 
                     :authorization="authorization"
                     :countries="countries"
                     :orderStates="orderStates"
                     :marketAccounts="marketAccounts"
                     :vendors="vendors"
                     :queryInProgress="queryInProgress"
                  ></coi-list>
               </div>
            <!-- /b-overlay -->
         </div>
      </div>
      <modal-error-component v-model="modalError"></modal-error-component>
   </b-row>
</template>
<style>
.customerOrderItems {
   position: fixed;
   overflow-x: hidden;
   overflow-y: hidden;
   overflow: scroll;
   height: 85%;
}
.two {
   grid-column: 3 / 4;
   grid-row: 1 / 3;
}
</style>
<script>
//import COIPagination from './COIPagination.vue';
   import { useUserPreferenceStore } from '../../stores/UserPreferenceStore';
import ModalErrorComponent from "../ModalErrorComponent.vue";

export default {
	components: {ModalErrorComponent},
   setup(){
      const userPreferenceStore = useUserPreferenceStore();
      return {userPreferenceStore}
   },
   props: [
      "customerOrderId", "isMaster", "marketOrderId"/* if id is set, then we search for this customerOrderId/marketOrderId immediately TODO THIS NEEDS TO HAPPEN IN THIS COMPONENT NOW! */,
   ],
   data() {
      return {
         countries: null,
         tDim: {
            height: this.window.innerHeight - 75,
            width: this.window.innerWidth - 500,
            pagination: null,
         },
				 modalError: { show: false, title: "", message: "", error: "" },
         customerOrders: [],
         pagination: {
            // we guarantee to the child component, that we won't mutate the pagination (from here it should be read-only).
            userPageChange: true,
            currentPage: 1,
            perPage: 5,
            totalRows: 0,
            orderBy: "-",
         },
         customerOrderCount: 0, // bound to coi-pagination aka totalRows in Bootstrap-Vue
         query: {
            // bound to coi-query
            limit: 10,
            offset: 0,
            count: null, // ~~if count is set, we use limit and offset~~ too opaque, using bool instead
            orderBy: null,
            orderByAscending: true,

            lastQueryTimestamp: null, //is timestamp of last query run, additionally we can add lateron a button "re-run query", this way we can re-run the query if lastQueryTimestamp is greater than some value.
            selectedDateRange: {
               type: null,
               from: null,
               to: null,
            },
            customerNameAndEmail: null, // this is not in customer object because it isn't a reference to a specific table member, it is both firstName and lastName
            customerAddress: null, // member represents all address metadata (street1, street2, zipcode, etc.)
            customerOrder: {
               id: null, // TODO check if coi.id shouldn't be used instead.
               customerOrderItem: {
                  id: null,
                  customerOrderItemDeliveryAddition: { shippingId: null },
                  stock: { material: { name: null, ean: null } },
               },
               marketOrderId: null,
               marketAccountId: null,
               orderState: null,
               orderTime: null,
               vendorId: null,
               shippingTypes: null
            },
         },
         activeSqlQuery: "", // string representation of the previously executed database query, for dev-debugging purposes.
         authorization: null,
         marketAccounts: null,
         queryInProgress: false,
         queryResponse: null,
         vendors: null,
         tHeight: this.window.innerHeight - 140,
         orderStates: {
            types: {
               "-1": "Offen",
               0: "Neu",
               1: "Erledigt",
               2: "Freigegeben",
               3: "Erstattung ausstehend",
               4: "Erstattet",
               5: "In Bearbeitung",
            },
            codes: {
               STATUS: -2,
               OPEN: -1,
               NEW: 0,
               DONE: 1,
               WAIT: 2,
               REFUND: 3,
               REFUND_OK: 4,
							 IN_PROGRESS: 5,
            },
         },
         shippingTypes: {
            types: {
               0: 'Normal',
               1: 'Einschreiben',
               2: 'Expressversand',
               3: 'FBA',
               4: 'Prime',
               7: 'Tracked'
            },
            codes:{
               SHIPPING_TYPE_NORMAL : 0,  
               SHIPPING_TYPE_REGISTERED : 1,  
               SHIPPING_TYPE_EXPRESS : 2,
               SHIPPING_TYPE_MARKET_FULFILLMENT : 3,
               SHIPPING_TYPE_SELLER_PRIME : 4,
               // SHIPPING_TYPE_SELLER_PRIME_2 : 5,
               // SHIPPING_TYPE_SELLER_PRIME_STD : 6,
               SHIPPING_TYPE_TRACKED : 7,
            },
         },
      }
   },
   computed: {
      orderByLabel: function () {
         if (this.pagination && this.pagination.orderBy) {
            const pretty = (s) =>
               this.pagination.orderByAscending
                  ? `${s}, neuste zuerst`
                  : `${s}, älteste zuerst`;

            if (
               "orderTime" == this.pagination.orderBy.substr(0, "orderTime".length)
            ) {
               return pretty("Bestelldatum");
            } else if (
               "deliveryDate" ==
               this.pagination.orderBy.substr(0, "deliveryDate".length)
            ) {
               return pretty("Versanddatum");
            } else if ("id" == this.pagination.orderBy.substr(0, "id".length)) {
               return pretty("ID");
            } else {
               alert("unknown orderBy field");
            }
         }
         return "-";
      },
   },
   methods: {
      computeTDim() {
         this.tDim = {
            height: this.window.innerHeight - 75,
            width:
               this.window.innerWidth -
               45 -
               document.getElementById("coi-query").clientWidth,
            windowWidth: window.innerWidth,
            pagination: document
               .getElementById("div-pagination")
               .getBoundingClientRect().bottom,
         };
      },
      newQueryScaffolding() {
         //WARNING: if you change this, you need to change it in the other components as well!
         return {
            limit: 10,
            offset: 0,
            count: null, // ~~if count is set, we use limit and offset~~ too opaque, using bool instead
            orderBy: null,
            orderByAscending: true,
            lastQueryTimestamp: null, //is timestamp of last query run, additionally we can add lateron a button "re-run query", this way we can re-run the query if lastQueryTimestamp is greater than some value.
            selectedDateRange: {
               type: null,
               from: null,
               to: null,
            },
            customerNameAndEmail: null, // this is not in customer object because it isn't a reference to a specific table member, it is both firstName and lastName
            customerAddress: null, // member represents all address metadata (street1, street2, zipcode, etc.)
            customerOrder: {
               id: null, // TODO check if coi.id shouldn't be used instead.
               customerOrderItem: {
                  id: null,
                  vendor: { id: null },
                  customerOrderItemDeliveryAddition: { shippingId: null },
                  stock: { material: { name: null, ean: null } },
               },
               marketOrderId: null,
               marketAccountId: null,
               orderState: null,
               orderTime: null,
               shippingTypes: null,
            },
         };
      },

      /**
       * @param mutation:{ customerOrders:[], ... }
       */
      compileCustomerOrders(raw) {
         if (!raw) {
            console.log( "compileCustomerOrders called with undefined or null customerOrders-param.. nothing to do." );
            this.$bvToast.toast("compileCustomerOrders called with undefined or null customerOrders-param.. nothing to do.", { title: "Customer Order Index", noAutoHide: true, appendToast: false, variant: 'danger' });
            return;
         }
         return raw.map(this.compileCustomerOrder);
         // .sort( (v, w) => {
         //    const comp = "ASC" === raw.query.orderBy.substr(-3) ? (a, b) => a < b : (a, b) => a > b;
         //    switch (raw.query.orderBy) 
         //    {
         //       case "orderTime": return comp(v.orderTime, w.orderTime);
         //       default:          return comp(v.id, w.id);
         //    }
         // });
      },
      compileCustomerOrder(customerOrder) {
         if (!customerOrder) {
            console.error("compileCustomerOrder called for null or undefined");
            alert( "Fehler: 'compileCustomerOrder called for null or undefined' bitte melden." );
            return;
         }

         customerOrder.customerOrderItemHistoryDeliveryJobLastUpdateTime = null;
         customerOrder.customerOrderItemHistoryMoveToMultiorderLastUpdateTime = null;
         customerOrder.isVendorChange = false;
         customerOrder.isReorder = false;
         for (let h of customerOrder.customerorderhistories) {
           console.log("processing history with id: " + h.id + " and reason: " + h.lastUpdateReason);

            if (
               h.lastUpdateReason &&
               h.lastUpdateReason.includes("Delivery Job") &&
               (customerOrder.customerOrderItemHistoryDeliveryJobLastUpdateTime ==
                  null ||
                  customerOrder.customerOrderItemHistoryDeliveryJobLastUpdateTime >
                     null)
            ) {
               customerOrder.customerOrderItemHistoryDeliveryJobLastUpdateTime =
                  h.lastUpdateTime; // aka Meldedatum
            }

           if (
               h.comment &&
               h.comment.includes("In Multiorder verschoben") &&
               (customerOrder.customerOrderItemHistoryMoveToMultiorderLastUpdateTime == null ||
                   customerOrder.customerOrderItemHistoryMoveToMultiorderLastUpdateTime > h.lastUpdateTime)
           ) {
             customerOrder.customerOrderItemHistoryMoveToMultiorderLastUpdateTime = h.lastUpdateTime; // move to multi date
             console.log("found multiorder move for customerOrder.id: " + customerOrder.id + " with history id: " + h.id);
           }

            customerOrder.isVendorChange =
               customerOrder.isVendorChange ||
               (h.comment && h.comment.includes("Umbestellung"));
            customerOrder.isReorder =
               customerOrder.isReorder ||
               (h.comment && h.comment.includes("Neubestellung"));
         }
         //if, by chance, the Marketplace is Priceminister (3) and no 'Delivery Job' History exists, just use the COID.submissionTime
         if ( [ "0000-00-00 00:00:00", "1999-11-30 00:00:00", "", null, undefined ]
            .includes( customerOrder.customerOrderItemHistoryDeliveryJobLastUpdateTime ) 
            && customerOrder.marketAccountId == 3 /*DANGER*/
         ){
            //marvelous, truly
            try{
            customerOrder.customerOrderItemHistoryDeliveryJobLastUpdateTime =
               customerOrder.customerorderitems[0].customerorderitemdeliveries[0].deliverySubmissionTime;
            }catch(error) {
               // TODO this is a quick fix and needs to be reviewed.
               customerOrder.customerOrderItemHistoryDeliveryJobLastUpdateTime = null
            }
         }

         customerOrder.marketAccount = this.marketAccounts.find(
            (marketAccount) => marketAccount.id == customerOrder.marketAccountId
         );

         //this is needed for showing price in euro and foreign currency symbol (it depends on MaretAccount's country  and not on address or vendor country. Additionally, customerOrderItem only holds information about the exchange rate and does not note the original currency ISO or congruent info, which makes this necessary).
         if (!customerOrder.marketAccount) {
            console.log("WARNING: marketAccount is not defined!");
         }

         customerOrder.marketAccount.country = this.countries.find(
            (country) => country.id == customerOrder.marketAccount.countryId
         );

         if (!customerOrder.address.country) {
            customerOrder.address.country = this.countries.find(
               (country) => country.id == customerOrder.address.countryId
            );
         }

         try {
            const vendor = this.vendors.find(
               (v) => v.id == customerOrder.customerorderitems[0].stock.vendorId
            );
            customerOrder.customerorderitems[0].stock.vendorName = vendor.name;
         } catch (error) {
            console.log(`could not find vendor for customerOrder.id:" ${customerOrder.id}`);
            console.error(error);
            if (customerOrder.customerorderitems[0]) {
               customerOrder.customerorderitems[0].stock.vendorName = "UNKNOWN";
            } else {
               console.log(`could not find stock or customerOrderItem for customerOrder.id:" ${customerOrder.id}`);
            }
         }
         return customerOrder;
      },
      mutatedCustomerOrder(customerOrder) {
         console.log( "called CustomerOrderIndex::mutatedCustomerOrder on order: ", customerOrder );
         for (let k = 0; k < this.customerOrders.length; ++k) {
            if (this.customerOrders[k].id == customerOrder.id) {
               this.customerOrders[k] = this.compileCustomerOrder(customerOrder); // customerOrder needs to be recompiled.
               break;
            }
         }
      },
      mutatedActiveQuery(activeQuery) {
         this.$refs.COIPagination.setCurrentPage( Math.floor(activeQuery.offset / activeQuery.limit) + 1);
         this.query = activeQuery;
         // this.userPreferenceStore.coi.activeQuery = activeQuery;
         this.executeQuery();
      },
      mutatedPagination(pagination) {
         this.pagination = pagination;
         this.executeQuery();
      },
      /** builds query out of this.query and this.pagination
       *  which can be sent as a POST object to CustomerOrderCtrl.
       *  Used by executeQuery()
       */
      buildQuery() {

         this.query.offset = 0;
         let query = this.query;
         // translate bootstrap-vue pagination info into mysql terms.
         query.limit   = this.pagination.perPage;
         query.offset  = this.pagination.perPage * Math.max(0, this.pagination.currentPage - 1);
         query.orderBy = this.pagination.orderBy;
         if(this.pagination.orderBy) {
            query.orderByAscending = "ASC" === this.pagination.orderBy.substr(-3);
         }else{
            query.orderByAscending = true;
         }
         return query;
      },
      executeQuery() {
         if(this.queryInProgress) {
            this.$bvToast.toast( "Eine Queryanfrage läuft bereits.", { title: "Customer Order Index", autoHideDelay: 3000, appendToast: false, variant: 'warning' });
            return;
         }
         this.customerOrderCount = null;
         this.queryInProgress = true;
         this.$emit('query-in-progress', true);
         Promise.all([
            axios.post("/customerorder/query", this.buildQuery()),
            new Promise((r) => setTimeout(r, 500)),
         ]).then(([response]) => {
            this.queryInProgress = false;
            this.$emit('query-in-progress', false);
            this.activeSqlQuery = response.data.sql;
            while (this.activeSqlQuery.indexOf("\n ") != -1) this.activeSqlQuery = this.activeSqlQuery.replace("\n ", "\n");
            this.customerOrders = this.compileCustomerOrders( response.data.customerOrders ); 
            if( response.data.customerOrders && 0 === response.data.customerOrders.length ){
               return Promise.resolve({ data: { count: 0 } });
            } // if clearly less and first request, we can assume we got all elements
            else if( this.query.count === null && response.data.customerOrders.length < this.query.limit ) {
               return Promise.resolve({ data: { count: response.data.customerOrders.length } });
            } else if (this.query.count) {
               // if a count has been determined, then user probably has picked a different page
               return Promise.resolve({ data: { count: this.query.count } });
            }
            return axios.post("/customerorder/query/count", this.query);
         })
         .then( response => {
            this.query.count = response.data.count;
            this.customerOrderCount = response.data.count;
         })
         .catch( error => {
						this.queryInProgress = false;
						this.modalError = {
							show: true,
							title: "Fehler bei der Anfrage",
							message: "Beim Ausführen der Anfrage ist ein Fehler aufgetreten.",
							error: error,
						}
				 });
       }

   },
   created() 
   {
      document.documentElement.style = "overflow-x:hidden!important;";
      if(this.customerOrderId) {
         this.query.customerOrder.id = this.customerOrderId;
         this.queryInProgress = false;
         this.buildQuery();
      }

		 if(this.marketOrderId) {
			 console.log("initializing coi with marketOrderId: " + this.marketOrderId);
			 this.query.customerOrder.marketOrderId = this.marketOrderId;
			 this.queryInProgress = false;
			 this.buildQuery();
		 }

      Promise.all([
         axios.get("/marketaccount/all"),
         axios.get("/vendor/all"),
         axios.get("/country/all"),
         axios.get("/user/authorization"),
      ]).then(([_marketAccount, _vendor, _country, _authorization]) => {
         this.marketAccounts = _marketAccount.data;
         this.vendors = _vendor.data;
         this.countries = _country.data;
         this.authorization = _authorization.data;
      });
   },
   mounted() {
      this.$nextTick(() => {
         window.addEventListener("resize", () => {
            this.tHeight = window.innerHeight - 140;
            this.computeTDim();
         });
         this.computeTDim();
      });
	   this.userPreferenceStore.coi.isMaster = this.isMaster
   },
};
</script>
